module.exports = __webpack_public_path__ + "static/br-516e96090ace30f5e090c08a092a7e92.svg";